import React, { useContext, useEffect } from 'react'
import * as _ from 'remeda'
import SettingContainerStep2 from "app/React/Components/Form/Step2/SettingContainerStep2";
import SettingStep2 from "app/React/Components/Form/Step2/SettingStep2";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function FormStep2(props) {
  const {
    isDealerConfigurator,
  } = useContext(ConfiguratorContext)

  if (isDealerConfigurator) {
    return null
  }

  const form = props.form
  const settings = Array.isArray(form.settings) ? { ...form.settings } : form.settings

  const setting_elements = _.pipe(
    Object.keys(settings ?? {}),
    _.sortBy((key) => settings?.[key]?.ordering),
    _.map((key) => {
      const setting = settings[key]
      return <SettingStep2 key={key} setting={setting}/>
    })
  )

  useEffect(() => {
    const form_el = document.getElementsByClassName('form')
    if (form_el.length > 0) {
      form_el[0].scrollTo(0, 0)
    }
    window.scrollTo(0, 0)
  }, [])

  return (
    <SettingContainerStep2>
      <div className='form sticky' onScroll={props.onElScroll}>
        <h1 className='mobile-config-title config-title' ref={props.titleRef}>
          {form.title}
        </h1>
        {setting_elements}
        {props.children}
        {typeof form.description === 'string' && form.description.length > 0 ? (
          <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: form.description }}/>
        ) : null}
      </div>
    </SettingContainerStep2>
  )
}
